import { render, staticRenderFns } from "./RevenueData.vue?vue&type=template&id=19d36000"
import script from "./RevenueData.vue?vue&type=script&lang=js"
export * from "./RevenueData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports